<template>
  <div class="exhibitor_list">
    <div class="list_wrap">
      <List v-model="loading" :finished="finished" @load="loadMore" finished-text="It's the end~">
        <div class="zs" v-for="(item, index) in list" :key="index">
          <div class="zs-row s-left">
            <div
              class="zs-row-box-top"
              @click="
                LinkExInvitation({
                  companyId: item.compId,
                  exhibitorId: item.id,
                  exhibitionId: item.exhibitionId,
                })
              "
            >
              <div class="zs-item">
                <div class="zs-logo">
                  <img :class="{ square_logo: configLogoIsSquare }" v-if="item.company && item.company.logo" :src="item.company.logo" v-load="'oPic'" />
                  <img v-else-if="exhibitionInfo && exhibitionInfo.exhibition && exhibitionInfo.exhibition.logo" :src="exhibitionInfo.exhibition.logo" v-load="'oPic'" />
                  <img :class="{ square_logo: configLogoIsSquare }" v-else src="@/assets/img/empty.png" />
                </div>
                <!-- 公司信息 -->
                <div class="zs-test">
                  <div class="zs-test-title">
                    <p>{{ item.company.nameEn }}</p>
                    <div class="is_live" v-if="item.isLiving">
                      <span></span>
                      直播中
                    </div>
                    <div class="is_live is_hot" v-if="item.isPopularize">
                      <i class="icon iconfont icon-huo"></i>
                      hot
                    </div>
                  </div>

                  <div class="zs-test-rank" v-if="item.continuouNumber">
                    <div class="type">
                      <div class="img">
                        <img src="@/assets/img/icon/icon-gold.png" v-if="item.continuouNumber > 7" />
                        <img src="@/assets/img/icon/icon-copper.png" v-else-if="item.continuouNumber < 5" />
                        <img src="@/assets/img/icon/icon-silver.png" v-else />
                      </div>
                      <span> Participated in {{ item.continuouNumber }} consecutive exhibitions </span>
                    </div>
                  </div>

                  <!-- 公司下的小标签><-->
                  <div class="zs-test-booth">
                    <div class="zs-tag zs-booth" v-if="item.boothInfo">
                      <i class="iconfont icon-dizhi"></i>
                      <p>{{ item.boothInfo }}</p>
                    </div>
                    <div class="zs-tag zs-type" v-if="item.categoryEn">
                      <i class="iconfont icon-biaoqian1"></i>
                      <p>{{ item.categoryEn }}</p>
                    </div>
                  </div>

                  <!-- 数据 -->
                  <div class="zs-test-count">
                    <p>
                      <span
                        ><i>{{ item.productNumber }}</i
                        >product(s)</span
                      >
                      <span
                        ><i>{{ item.activityNumber }}</i
                        >activity(s)</span
                      >
                      <span
                        ><i>{{ item.liveCount }}</i
                        >live(s)</span
                      >
                    </p>
                  </div>

                  <div class="zs-item-bottom" v-if="item.products.length">
                    <swiperCard :products="item.products" v-if="item.products.length"></swiperCard>
                    <!-- <p class="zs-item-news" v-if="item.newestEvaluates[0]">
                      <span>最新评价：</span
                      >{{ item.newestEvaluates[0].content }}
                    </p> -->
                    <!-- <div
                      class="zs-item-zan"
                      v-if="item.likes && item.likes.length"
                    >
                      <template v-for="(item, index) in item.likes">
                        <img
                          :src="JSON.parse(item.userInfo).avatarUrl"
                          
                          v-if="JSON.parse(item.userInfo).avatarUrl"
                          :key="index"
                        />
                        <img
                          src="@/assets/img/empty.png"
                          
                          v-else
                          :key="index"
                        />
                      </template>
                      <p>{{ item.likeCount }} like(s)</p>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div slot="loading" class="f-tac loading">
          <img src="@assets/img/new/icon-loading.png" />
          loading...
        </div>
        <div slot="finished" class="f-tac loading">It's the end~</div>
      </List>
    </div>
    <!-- 索取样品 -->
    <inquiry ref="inquiry"></inquiry>
  </div>
</template>

<script>
import gql from "graphql-tag";
import inquiry from "@/components/inquiry/index"; // 索取样品
import { List } from "vant";
import { mapGetters, mapActions } from "vuex";
import swiperCard from "../../../exhibition/component/swiper-card";
export default {
  name: "exhibitor-list",
  data() {
    return {
      loading: false, //展商加载状态
      finished: false, //展商是否完成状态
      list: [], //展商列表
      pageIndex: 0,
      pageSize: 20,
      queryExhibitorFollow: {},
    };
  },
  components: { List, inquiry, swiperCard },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      exhibitionId: "getExhibitionId",
      exhibitionInfo: "getExhibitionInfo",
      configLogoIsSquare: "getConfigLogoIsSquare",
    }),
  },
  created() {},
  methods: {
    ...mapActions({
      LinkProduct: "linkTo/LinkProduct",
      LinkExInvitation: "linkTo/LinkExInvitation",
    }),
    //打开询盘 点击索取样品
    openInquiry(item) {
      this.$store.commit("company/setExhibitorId", item.id);
      this.$store.commit("company/setCompanyId", item.compId);
      let exInfo = {
        compLogo: item.company.logo,
        compName: item.company.name,
        boothInfo: item.boothInfo,
      };
      this.$refs.inquiry.open(exInfo);
    },
    getList() {
      let query = gql`
        query queryExhibitorFollow($query: QueryInput!) {
          queryExhibitorFollow(query: $query) {
            hasNextPage
            indexFrom
            pageIndex
            pageSize
            items {
              exhibitor {
                activities(num: 3) {
                  id
                  title
                }
                banner
                boothArea
                boothInfo
                businesses(num: 3) {
                  id
                  remark
                  isSample
                }
                category
                categoryEn
                company {
                  id
                  logo
                  name
                  nameEn
                  category
                  region
                  address
                }
                compId
                exhibitionId
                followCount
                id
                isPopularize
                isLiving
                likeCount
                lookCount
                productNumber
                activityNumber
                liveCount
                continuouNumber
                likes {
                  userInfo
                }
                newestEvaluates {
                  id
                  content
                }
                products(num: 10) {
                  id
                  exhibitorId
                  banner
                  view3DUrl
                }
                shareCount
                talkCount
                thinkCount
                userCount
                viewCount
              }
            }
          }
        }
      `;
      let where = {
        Equal: {
          n: "userId",
          v: this.userInfo.userId,
        },
        EqualB: {
          n: "exhibitionId",
          v: this.exhibitionId,
        },
      };
      let order = [
        {
          N: "createAt",
          v: 0,
        },
      ];
      let opt = {
        page: this.pageIndex,
        size: this.pageSize,
        where: JSON.stringify(where),
        order: JSON.stringify(order),
      };
      this.$apollo.addSmartQuery("queryExhibitorFollow", {
        query: query,
        variables: {
          query: opt,
        },
        fetchPolicy: "network-only", //清理缓存
        result(data) {
          let res = JSON.parse(JSON.stringify(data.data.queryExhibitorFollow));
          // let res=data.data.queryProduct;
          // console.log('关注展商',res);
          let items = [];
          if (res && res.items.length) {
            res.items.forEach((el) => {
              items.push(el.exhibitor);
            });
          }
          if (items.length) {
            items.forEach((c) => {
              console.log(c, "cccccccccc");
              if (c.category && c.category.indexOf("[") !== -1) {
                if (c.category !== "[null]") {
                  c.category = JSON.parse(c.category)[0].Value;
                } else {
                  c.category = "";
                }
              }
              if (c.categoryEn && c.categoryEn.indexOf("[") !== -1) {
                if (c.categoryEn !== "[null]") {
                  c.categoryEn = JSON.parse(c.categoryEn)[0].Value;
                } else {
                  c.categoryEn = "";
                }
              }
            });
          }
          if (this.pageIndex == 1) {
            this.list = items;
          } else {
            this.list = [...new Set([...this.list, ...items])];
          }
          this.loading = false;
          if (!res.hasNextPage) {
            this.finished = true;
          }
          console.log(res, "res");
        },
        error(err) {
          this.loading = false;
          this.finished = true;
          console.log("err", err);
        },
      });
    },
    loadMore() {
      console.log("load");
      if (this.finished) return;
      this.pageIndex += 1;
      this.getList();
    },
  },
};
</script>

<style scoped lang="scss">
//展品列表
.exhibitor_list {
  .list_wrap {
    .zs {
      width: 100%;
      box-sizing: border-box;
      padding: 0.3rem 0;
      border-top: 1px solid #f4f4f4;
      &:first-child {
        border-top: none;
        padding-top: 0;
      }
      &-item {
        display: flex;
        flex: 1;
        // align-items: center;
        .zs-number {
          color: #333;
          font-weight: bold;
          font-size: 0.28rem;
          flex-shrink: 0;
        }
        .zs-logo {
          // margin-left: .3rem;
          position: relative;
          box-sizing: border-box;
          flex-shrink: 0;
          img {
            width: 1.2rem;
            height: 1.2rem;
            display: block;
            box-sizing: border-box;
            border-radius: 50%;
            border: 1px solid #eaeaea;
            &.empty-img {
              opacity: 1;
              width: 100%;
              height: auto;
              position: absolute;
              margin: auto;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
            }
          }
        }
        .zs-test {
          padding-left: 0.15rem;
          // height: 1.4rem;
          // justify-content: space-between;
          width: calc(100% - 1.2rem);
          &-booth {
            max-width: 95%;
            display: flex;
            align-items: center;
            overflow: hidden;
            height: 0.4rem;
            font-size: 0.2rem;
            color: #666;
            margin-top: 0.08rem;
            margin-left: -0.09rem;
            .zs-addr {
              font-size: 0.2rem;
              flex-shrink: 0;
              margin-right: 0.2rem;
            }
            .zs-tag {
              box-sizing: border-box;
              border-radius: 0.05rem;
              display: flex;
              align-items: center;
              color: #333;
              .iconfont {
                color: #1890ff;
                font-size: 0.42rem;
                transform: translateY(0.03rem);
              }
              .icon-biaoqian1 {
                position: relative;
                top: -0.02rem;
              }
              .icon-dizhi {
                color: #fe781d;
                position: relative;
                top: -0.04rem;
                font-size: 0.38rem;
              }
              p {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
            .zs-booth {
              margin-right: 0.15rem;
            }
            .zs-type {
              overflow: hidden;
            }
          }
          .item-padd {
            margin: 6px 0 5px;
            display: flex;
            align-items: center;
            font-size: 12px;
            color: #999;
            flex-wrap: wrap;
            .brand {
              line-height: 1.2;
              margin-right: 8px;
              span {
                color: #999;
                line-height: 18px;
                display: inline-block;
                display: flex;
                align-items: center;
                .icon-zhiboguankanshu {
                  position: relative;
                  top: -1px;
                }
                .icon-dianzan {
                  position: relative;
                  top: -2px;
                }
              }
              .iconfont {
                font-size: 18px;
                display: inline-block;
                margin-right: 2px;
                color: #999;
              }
            }
          }
          &-title {
            max-width: 95%;
            display: flex;
            align-items: center;
            p {
              color: #333;
              font-weight: 600;
              font-size: 0.3rem;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              min-height: 0.34rem;
            }
            .is_live {
              width: 0.88rem;
              height: 0.3rem;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-shrink: 0;
              color: #fff;
              margin-left: 0.15rem;
              background-image: linear-gradient(90deg, #ff416c 0%, #ff4b2b 100%), linear-gradient(#000, #000);
              background-blend-mode: normal, normal;
              border-radius: 0.05rem;
              color: #fff;
              font-size: 0.18rem;
              // vertical-align: middle;
              span {
                display: block;
                height: 0.12rem;
                width: 0.12rem;
                margin-right: 0.06rem;
                border-radius: 50%;
                background: #fff;
              }
            }
            .is_hot {
              background: #ff5c00;
            }
            .hot_tag {
              width: 0.68rem;
              height: 0.24rem;
              display: flex;
              justify-content: center;
              align-items: center;
              color: #fff;
              flex-shrink: 0;
              background-color: #ff5c00;
              border-radius: 0.05rem;
              font-size: 0.14rem;
              margin-left: 0.1rem;
              .iconfont {
                margin-left: -0.06rem;
                font-size: 0.28rem;
                // transform: scale(1.3);
              }
            }
          }
          .english_name {
            max-width: 95%;
            font-size: 0.24rem;
            font-weight: bold;
            line-height: 0.32rem;
            color: #333;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          &-icon {
            display: flex;
            font-size: 0.2rem;
            position: relative;
            .jyb_text {
              position: absolute;
              left: 0;
              bottom: -0.35rem;
              width: 100%;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              color: #999;
              font-size: 0.2rem;
              span {
                color: #ff5c00;
              }
            }
            .icon_jyb {
              width: 0.84rem;
              height: 0.3rem;
              border-radius: 0.04rem;
              margin-top: 0.15rem;
              display: flex;
              align-items: center;
              justify-content: center;
              background: rgba(248, 90, 16, 0.1);
              img {
                width: 0.54rem;
                height: 0.23rem;
                display: block;
              }
            }
            .icon_tag {
              margin-top: 0.1rem;
              height: 0.3rem;
              padding: 0 0.08rem 0 0.05rem;
              color: #fff;
              border-radius: 0.04rem;
              display: flex;
              align-items: center;
              margin-right: 0.1rem;
              &:last-child {
                margin-right: 0;
              }
              &.rz {
                background-color: #ffb528;
              }
              &.qy {
                background-color: #108ee9;
              }
              .iconfont {
                transform: translateY(1px);
              }
            }
          }
          &-rank {
            margin-top: 0.14rem;
            .type {
              display: flex;
              //width: 1.85rem;
              height: 0.42rem;
              background-color: rgba(255, 94, 0, 0.15);
              border: solid 1px #ffe7d9;
              .img {
                width: 0.42rem;
                height: 100%;
                background: #fff;
                img {
                  width: 0.3rem;
                  height: 0.3rem;
                  display: block;
                  margin: 0.06rem 0 0 0.06rem;
                }
              }
              span {
                font-size: 0.22rem;
                line-height: 0.42rem;
                color: #ff5e00;
                display: inline-block;
                text-align: center;
                flex: 1;
              }
            }
          }
          &-count {
            margin-top: 0.08rem;
            p {
              font-size: 0.24rem;
              font-weight: normal;
              line-height: 0.3rem;
              color: #333;
              i {
                font-style: normal;
                color: #fe781d;
                margin-right: 0.08rem;
              }
              span {
                margin: 0 0.1rem;
              }
            }
          }
          .rc-row2 {
            margin-top: 0.04rem;
            color: #666;
            line-height: 0.2rem;
            font-size: 0.12rem;
            color: rgb(102, 102, 102);
            &_item {
              margin-bottom: 0.05rem;
              word-break: break-all;
            }
          }
        }
        &-blist {
          z-index: 2;
          position: relative;
          &_one {
            img {
              width: 100%;
            }
            p {
              font-size: 0.13rem;
              margin-top: 0.06rem;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
        &-bact {
          z-index: 2;
          position: relative;
          .rc-row2_item {
            margin-bottom: 0.1rem;
            font-size: 0.12rem;
            color: #666;
            line-height: 1.5;
            &:only-child,
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
        &-act {
          margin-top: 15px;
          .van-notice-bar {
            background: #fff;
            color: #666;
            padding: 0;
            height: 0.46rem;
            .notice-swipe {
              height: 0.46rem;
              width: 100%;
            }
            .act-list {
              line-height: initial;
              p {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              span {
                width: 0.48rem;
                height: 0.28rem;
                background-color: #f0eded;
                border-radius: 0.02rem;
                border: solid 1px #d27976;
                color: #e4514c;
                font-size: 0.18rem;
                text-align: center;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 2px;
                flex-shrink: 0;
                // line-height: .28rem;
              }
              .bus {
                background-color: #ffefe5;
                border: solid 1px #ff5d00;
                color: #ff5e00;
              }
              &-p {
                display: flex;
                align-items: center;
                height: 0.28rem;
                p {
                  // max-width: 75%;
                  margin-left: 0.08rem;
                }
                //&.hd {
                //p {
                // max-width: calc(100% - 0.6rem);
                //}
                //}
                .no-span {
                  max-width: 95%;
                }
                .remark {
                  margin-left: 0.08rem;
                  font-size: 0.22rem;
                  border: none;
                  border-bottom: 1px solid #199bff;
                  color: #199bff;
                  padding: 0;
                  background: transparent;
                  width: auto;
                  height: 0.28rem;
                }
              }
            }
          }
        }
      }
      .zs-row {
        &.s-left {
          padding-left: 0;
        }
        &-box {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
        }
        .zs-img-box {
          position: relative;
          width: 0.6rem;
          height: 0.6rem;
          box-sizing: border-box;
          margin-left: 0.04rem;
          display: inline-block;
          flex-shrink: 0;
          img {
            width: 0.6rem;
            height: 0.6rem;
            display: inline-block;
            border-radius: 50%;
            border: 1px solid #eaeaea;
            &.empty-img {
              opacity: 1;
              width: 100%;
              height: auto;
              position: absolute;
              margin: auto;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
            }
          }
        }
      }
      // .zs-item-center {
      //     display: flex;
      //     align-items: center;
      //   .zs-item-bottom-left{
      //     width: 1.4rem;
      //   }
      // .zs-item-bottom{
      //   padding-left: 0.15rem;
      //   width: calc(100% - 1.4rem);
      // }
      .zs-item-blist {
        font-size: 0;
        display: flex;
        position: relative;
        padding: 0.18rem 0.24rem;
        background: #fff;
        box-shadow: 0 0 0.1rem 0 rgba(0, 0, 0, 0.2);
        border-radius: 0.06rem;
        &_one {
          width: 31%;
          //  margin-right:20px;
        }
        &_one:nth-child(2n + 2) {
          margin: 0 3.5%;
        }
        &_imgbox {
          width: 100%;
          position: relative;
          height: 0;
          overflow: hidden;
          padding-bottom: 100%;
          .d_tag {
            position: absolute;
            z-index: 1;
            width: 0.6rem;
            height: 0.26rem;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #ff5c00;
            box-sizing: border-box;
            border-radius: 0 0 0 5px;
            color: #fff;
            font-size: 0.16rem;
            right: 0;
            top: 0;
            .iconfont {
              font-size: 0.28rem;
            }
          }
          img {
            position: absolute;
            width: 100%;
            height: 100%;
            // object-fit: cover;
            top: 0;
            left: 0;
          }
        }
      }
      .zs-item-news {
        width: 100%;
        margin-top: 0.2rem;
        background-color: #f7f7f7;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #666;
        padding: 4px 8px;
        span {
          color: #999;
        }
      }
      .zs-item-zan {
        min-width: 100px;
        height: 22px;
        display: flex;
        margin-top: 0.2rem;
        img {
          width: 22px;
          height: 22px;
          border-radius: 50%;
          display: block;
          border: 1px solid #fff;
        }
        img:nth-child(1) {
          z-index: 13;
          position: relative;
        }
        img:nth-child(2) {
          z-index: 12;
          position: relative;
          margin-left: -10px;
        }
        img:nth-child(3) {
          z-index: 11;
          position: relative;
          margin-left: -10px;
        }
        p {
          min-width: 48px;
          height: 23px;
          color: #999;
          font-size: 0.22rem;
          display: flex;
          align-items: center;
          justify-content: center;
          padding-left: 18px;
          margin-left: -10px;
          text-align: center;
          padding-right: 5px;
        }
      }
    }
  }
}
.f-tac {
  text-align: center;
}
.loading {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 18px;
    height: 18px;
    display: inline-block;
    margin-right: 5px;
    animation: 1s loader-01 linear infinite;
  }
}
@keyframes loader-01 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
